import {TileLayer, Marker, Popup, MapContainer, useMap, useMapEvents} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from "leaflet"
import {useCallback, useMemo, useRef, useState} from "react";

function DraggableMarker() {
    return null;
}

const CustomNeshanMap = ({markedLocation , onChange}) => {
    const [centerPosition] = useState([26.86450571560634, 55.83526611328126]);
    const [markedPosition, setMarkedPosition] = useState([markedLocation.lat, markedLocation.lng]);

    const defaultIcon = L.icon({
        iconUrl: icon,
        // shadowUrl: iconShadow,
        iconSize: [16, 25],
    });

    function DraggableMarker() {
        const [draggable, setDraggable] = useState(true)
        const [position, setPosition] = useState(markedPosition)
        const markerRef = useRef(null)
        const eventHandlers = useMemo(
            () => ({
                dragend() {
                    const marker = markerRef.current
                    if (marker != null) {
                        setPosition(marker.getLatLng())
                        setMarkedPosition(marker.getLatLng())
                        onChange(marker.getLatLng())
                    }
                },
            }),
            [],
        )

        return (
            markedPosition[0] && markedPosition[1] &&
            <Marker
                icon={defaultIcon}
                draggable={draggable}
                eventHandlers={eventHandlers}
                position={position}
                ref={markerRef}>
            </Marker>

        )
    }

    const MapEvents = () => {
        useMapEvents({
            click(e) {
                // setState your coords here
                // coords exist in "e.latlng.lat" and "e.latlng.lng"
                setMarkedPosition([e.latlng.lat, e.latlng.lng]);
                onChange([e.latlng.lat, e.latlng.lng]);
            },

        });
        return false;
    }


    return (
        <MapContainer style={{height: '350px'}} center={centerPosition} zoom={11} scrollWheelZoom={true}
        >
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <DraggableMarker/>
            <MapEvents/>
        </MapContainer>
    )

}

export default CustomNeshanMap;


